import styled from 'styled-components';

import { RailwaySearchInput, CalendarDayPicker } from 'components/ui/controls/SearchTickets';

export const CalendarsWrapper = styled.div`
  display: flex;
  width: 100%;
`;

export const RailwayInputWrapper = styled.div`
  display: flex;
  width: 100%;
  position: relative;
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  left: 50%;
  margin-left: -16px;
  top: 0;
  bottom: 0;
  cursor: pointer;
  user-select: none;
`;

export const Wrapper = styled.div`
  display: flex;
  background: #f2f4f6;
  border-radius: 4px;
  width: 80%;

  ${RailwaySearchInput} {
    width: 100%;
  }

  ${CalendarDayPicker} {
    width: 100%;
  }
`;
